import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface ReferenceData {
  title: {
    en: string;
    de: string;
  };
  imageUrl: string;
  imageAlt: {
    en: string;
    de: string;
  };
  description: {
    en: string;
    de: string;
  };
  buttons: {
    viewDetails: {
      en: string;
      de: string;
    };
    addToLibrary: {
      en: string;
      de: string;
    };
  };
}

const referenceData: ReferenceData = {
  title: {
    en: 'Trauma Checklist',
    de: 'Checkliste Traumatologie',
  },
  imageUrl:
    'https://images.thalia.media/00/-/7f42550e2853419db14a4aebc108278d/checkliste-traumatologie-set-mit-diversen-artikeln.jpeg',
  imageAlt: {
    en: 'Trauma Checklist',
    de: 'Checkliste Traumatologie',
  },
  description: {
    en: 'Medical reference guide for trauma cases',
    de: 'Medizinisches Nachschlagewerk für Traumafälle',
  },
  buttons: {
    viewDetails: {
      en: 'View Details',
      de: 'Details anzeigen',
    },
    addToLibrary: {
      en: 'Add to Library',
      de: 'Zur Bibliothek hinzufügen',
    },
  },
};

const generateMedicalReferenceContent = (lang: 'en' | 'de'): string => {
  return `
    <div style="display: flex; flex-direction: column; height: 100%; align-items: center; justify-content: center; text-align: center; background-color: #ffffff; color: #282a32; padding: 16px; border-radius: 8px; border: 1px solid #eff1f6;">
      <div style="font-weight: 600; margin-bottom: 12px; font-size: 1rem;">${referenceData.title[lang]}</div>
      <div style="width: 100%; height: 75%; display: flex; justify-content: center; align-items: center; background-color: #f8f9fa; border-radius: 8px; position: relative; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
        <img src="${referenceData.imageUrl}" alt="${referenceData.imageAlt[lang]}" style="max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 4px;" />
      </div>
      <div style="margin-top: 12px; display: flex; flex-direction: column; align-items: center; width: 100%;">
        <div style="font-size: 0.85rem; color: #686b87; margin-bottom: 8px;">
          ${referenceData.description[lang]}
        </div>
        <div style="display: flex; gap: 8px;">
          <button style="background-color: #434ce8; color: white; border: none; border-radius: 8px; padding: 8px 16px; font-size: 0.85rem; font-weight: 500; cursor: pointer; font-family: 'Be Vietnam Pro', sans-serif;">
            ${referenceData.buttons.viewDetails[lang]}
          </button>
          <button style="background-color: transparent; color: #434ce8; border: 1px solid #434ce8; border-radius: 8px; padding: 8px 16px; font-size: 0.85rem; font-weight: 500; cursor: pointer; font-family: 'Be Vietnam Pro', sans-serif;">
            ${referenceData.buttons.addToLibrary[lang]}
          </button>
        </div>
      </div>
    </div>`;
};

export const medicalReferenceWidget: MultilingualWidgetConfig = {
  id: 'medical-reference',
  translations: {
    en: {
      title: 'Medical Reference',
      content: generateMedicalReferenceContent('en'),
    },
    de: {
      title: 'Medizinisches Nachschlagewerk',
      content: generateMedicalReferenceContent('de'),
    },
  },
  x: 0,
  y: 0,
  w: 2,
  h: 8,
};
